export default __webpack_public_path__ + "static/media/ecommerce.cbd4fe09.jpg";